<template>
  <div id="app" :class="{ 'page-home': isHome }">
    <site-nav></site-nav>
    <router-view></router-view>
    <site-footer></site-footer>
    <!-- 全站登录/注册弹窗（由 store.state.showLogin 或 dts:auth-open 事件驱动） -->
    <auth-modal></auth-modal>
  </div>
</template>

<script>
import SiteNav from './components/SiteNav';
import SiteFooter from './components/SiteFooter';
import AuthModal from './components/AuthModal';

export default {
  name: 'App',
  components: {
    SiteNav,
    SiteFooter,
    AuthModal
  },
  computed: {
    // 首页需要透明导航叠在 Hero 上（对应 handoff 的 body.page-home）
    isHome() {
      return this.$route.path === '/';
    }
  }
};
</script>

<style>
/* 全局壳：页面背景与字体由 src/styles/site.css 的 body 规则统一控制 */
#app {
  color: #333333;
}
#app a {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue